import React, { useContext, useEffect } from 'react';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { ModalHeader, ModalBody, Typography, Button, LoadingButton, ModalFooter, } from '@one-thd/sui-atomic-components';
import { setResendUserInvitesOverlayAnalytics } from '../../../utils/add-manage-user-analytics';
export var MultiResendInvitesModal = function (_a) {
    var selectedPendingInviteUsers = _a.selectedPendingInviteUsers, isLoading = _a.isLoading, onConfirmMultiResend = _a.onConfirmMultiResend, hideModal = _a.hideModal, handleClose = _a.handleClose;
    var channel = useContext(ExperienceContext).channel;
    var isMobile = channel === 'mobile';
    var length = selectedPendingInviteUsers.length;
    var handleCancel = function () {
        hideModal();
        handleClose();
    };
    var height = '';
    if (isMobile && length > 4) {
        height = 'sui-h-[195px]';
    }
    else if (!isMobile && length > 9) {
        height = 'sui-h-[400px]';
    }
    useEffect(function () {
        setResendUserInvitesOverlayAnalytics();
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement(ModalHeader, { onClose: handleCancel }, "Resend User Invites"),
        React.createElement(ModalBody, null,
            React.createElement(Typography, { variant: "body-base", weight: "bold" }, "Do you want to invite ".concat(length, " user(s) to join your business account?")),
            React.createElement("div", { className: "sui-mt-4" },
                React.createElement(Typography, { variant: "body-base" }, "Once you complete this action, we\u2019ll email each user an invite with instructions to get started.")),
            React.createElement("div", { className: "sui-overflow-y-scroll ".concat(height) },
                React.createElement("ul", { className: "sui-list-disc sui-mt-4 sui-ml-6" }, selectedPendingInviteUsers.map(function (user) { return (React.createElement("li", { key: user.userId, className: "sui-mb-4" },
                    React.createElement("div", { className: "sui-flex" },
                        React.createElement(Typography, { variant: "body-base", weight: "bold", "data-qm-mask": "" },
                            user.firstName,
                            " ",
                            user.lastName),
                        "\u00A0",
                        React.createElement(Typography, { variant: "body-base", color: "subtle", weight: "bold" }, "(".concat(user.role, ")"))))); })))),
        React.createElement(ModalFooter, { position: "end" },
            React.createElement("div", { className: "sui-flex sui-gap-4 sm:sui-gap-4 sui-flex-col-reverse sui-w-full sm:sui-flex-row sm:sui-w-auto" },
                React.createElement(Button, { variant: "secondary", onClick: handleCancel }, "No"),
                React.createElement(LoadingButton, { loading: isLoading, variant: "primary", onClick: onConfirmMultiResend }, "Yes, Resend Invites")))));
};
MultiResendInvitesModal.displayText = 'MultiResendInvitesModal';
